"use client";
import {Heading, Highlight, Text, Stack} from "@chakra-ui/react";
import {Balancer} from "react-wrap-balancer";
import {TEXT_VARIANTS} from "@/theme/components/text";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";

type Props = {
  title?: string;
  text: string;
  highlightedText?: string | string[];
  children?: React.ReactNode;
};

const SimpleIntro = (props: Props) => {
  const HeadingVariant = useSectionHeadingVariant();
  const {title, text, highlightedText = [], children} = props;
  return (
    <Stack spacing={4} maxW={"8xl"} mx={"auto"}>
      {title && (
        <Balancer>
          <Heading
            as="h1"
            variant={HeadingVariant}
            textAlign={"center"}
            whiteSpace={"pre-line"}
          >
            {title}
          </Heading>
        </Balancer>
      )}
      <Balancer>
        <Text
          px={6}
          color="text.100"
          textAlign={"center"}
          variant={TEXT_VARIANTS.BODY1}
          whiteSpace={"pre-line"}
        >
          <Highlight
            query={highlightedText}
            styles={{fontWeight: 600, color: "text.100"}}
          >
            {text}
          </Highlight>
        </Text>
      </Balancer>
      {children && children}
    </Stack>
  );
};

export default SimpleIntro;
